import type { OverlayConfig } from './lib/compositor';
import type { Quality } from './lib/codecs';
import type { ExportContainer, ExportMode } from './lib/exporter';

export interface Settings {
  // Capture
  fps: number;
  quality: Quality;
  countdownMs: number;
  hideOwnTab: boolean;
  systemAudio: boolean;
  systemGain: number;
  micEnabled: boolean;
  micDeviceId: string;
  micGain: number;
  webcamEnabled: boolean;
  webcamDeviceId: string;
  overlay: OverlayConfig;
  // Export
  container: ExportContainer;
  mode: ExportMode;
  scale: number;
  /** `null` follows the take's own bitrate. */
  bitrateMbps: number | null;
  includeAudio: boolean;
  // Editor
  snapToKeyframes: boolean;
  loopTrim: boolean;
}

export const defaultSettings: Settings = {
  fps: 60,
  quality: 'high',
  countdownMs: 3000,
  hideOwnTab: true,
  systemAudio: true,
  systemGain: 1,
  micEnabled: false,
  micDeviceId: '',
  micGain: 1,
  webcamEnabled: false,
  webcamDeviceId: '',
  overlay: {
    corner: 'br',
    shape: 'rounded',
    mirror: true,
    scale: 0.22,
    margin: 0.035,
  },
  container: 'mp4',
  mode: 'fast',
  scale: 1,
  bitrateMbps: null,
  includeAudio: true,
  snapToKeyframes: true,
  loopTrim: true,
};

export const FPS_OPTIONS = [24, 30, 60] as const;
export const QUALITY_OPTIONS: Array<{ value: Quality; label: string }> = [
  { value: 'balanced', label: 'Balanced' },
  { value: 'high', label: 'High' },
  { value: 'max', label: 'Max' },
];
export const COUNTDOWN_OPTIONS = [
  { value: 0, label: 'Off' },
  { value: 3000, label: '3s' },
  { value: 5000, label: '5s' },
];
